export const SHARING_OPTIONS = [
  { value: "user", label: "User Only" },
  { value: "org-view", label: "Org View Only" },
  { value: "org-edit", label: "Org Edit" },
];

export function normalizeSharing(value) {
  const sharing = String(value || "user").trim();
  if (sharing === "org") return "org-view";
  if (sharing === "org-view" || sharing === "org-edit") return sharing;
  return "user";
}

export function getSharingPermissions(record = {}, profile = {}) {
  const createdBy = record?.created_by ?? record?.createdBy ?? null;
  const isSaved = !!record?.id;
  const isOwner = !!createdBy && !!profile?.id && createdBy === profile.id;
  const sharingMode = normalizeSharing(record?.sharing);

  const canEdit = !isSaved || isOwner || sharingMode === "org-edit";
  const canDelete = isSaved && isOwner;
  const canChangeSharing = !isSaved || isOwner;
  const isReadOnly = isSaved && !canEdit;
  const isLocked = isReadOnly;

  return {
    isOwner,
    canEdit,
    canDelete,
    canChangeSharing,
    isReadOnly,
    isLocked,
  };
}

export const getDebtStudioPermissions = getSharingPermissions;
